import React from 'react';
import { ShoppingBag } from 'lucide-react';
import { Button } from './ui/button';
import { SWIGGY_ORDER_URL, ZOMATO_ORDER_URL } from '../data/mockData';

const Hero = () => {
  const scrollToMenu = () => {
    const element = document.getElementById('menu');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="home" className="relative min-h-screen flex items-center pt-20 overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0 z-0">
        <img
          src="https://images.unsplash.com/photo-1742281258189-3b933879867a"
          alt="Traditional Indian Thali"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/80 via-black/60 to-transparent"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
        <div className="max-w-3xl">
          {/* Badge */}
          <div className="inline-flex items-center px-4 py-2 mb-6 bg-gradient-to-r from-yellow-400/90 to-pink-400/90 backdrop-blur-sm rounded-full">
            <span className="text-sm font-semibold text-gray-800">100% Pure Vegetarian</span>
          </div>

          {/* Main Heading */}
          <h1 className="text-5xl md:text-7xl font-bold mb-6">
            <span className="text-white">Welcome to</span>
            <br />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-yellow-300 to-pink-300">
              Ambarsariya
            </span>
          </h1>

          {/* Subheading */}
          <p className="text-xl md:text-2xl text-gray-200 mb-8 leading-relaxed">
            Authentic North Indian Vegetarian Cuisine
            <br />
            <span className="text-yellow-300">From Punjab's Heart to Your Plate</span>
          </p>

          {/* Features */}
          <div className="flex flex-wrap gap-4 mb-10">
            <div className="flex items-center gap-2 px-4 py-2 bg-white/10 backdrop-blur-sm rounded-lg border border-white/20">
              <div className="w-2 h-2 bg-yellow-400 rounded-full"></div>
              <span className="text-white font-medium">Traditional Tandoor</span>
            </div>
            <div className="flex items-center gap-2 px-4 py-2 bg-white/10 backdrop-blur-sm rounded-lg border border-white/20">
              <div className="w-2 h-2 bg-pink-400 rounded-full"></div>
              <span className="text-white font-medium">Mumbai & Delhi Street Food</span>
            </div>
            <div className="flex items-center gap-2 px-4 py-2 bg-white/10 backdrop-blur-sm rounded-lg border border-white/20">
              <div className="w-2 h-2 bg-yellow-400 rounded-full"></div>
              <span className="text-white font-medium">Authentic Recipes</span>
            </div>
          </div>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4">
            <Button
              onClick={scrollToMenu}
              size="lg"
              data-testid="hero-explore-menu-btn"
              className="bg-gradient-to-r from-yellow-400 to-yellow-500 hover:from-yellow-500 hover:to-yellow-600 text-gray-800 font-bold text-lg px-8 py-6 shadow-lg hover:shadow-xl transition-all"
            >
              Explore Menu
            </Button>
            <Button
              asChild
              size="lg"
              variant="outline"
              data-testid="hero-order-now-btn"
              className="bg-gradient-to-r from-orange-500 to-orange-600 hover:from-orange-600 hover:to-orange-700 border-2 border-orange-500 text-white font-bold text-lg px-8 py-6 shadow-lg hover:shadow-xl transition-all"
            >
              <a href={SWIGGY_ORDER_URL} target="_blank" rel="noopener noreferrer">
                <ShoppingBag className="w-5 h-5 mr-2" />
                Order on Swiggy
              </a>
            </Button>
            <Button
              asChild
              size="lg"
              variant="outline"
              data-testid="hero-order-zomato-btn"
              className="bg-gradient-to-r from-red-500 to-rose-600 hover:from-red-600 hover:to-rose-700 border-2 border-red-500 text-white font-bold text-lg px-8 py-6 shadow-lg hover:shadow-xl transition-all"
            >
              <a href={ZOMATO_ORDER_URL} target="_blank" rel="noopener noreferrer">
                <ShoppingBag className="w-5 h-5 mr-2" />
                Order on Zomato
              </a>
            </Button>
          </div>
        </div>
      </div>

      {/* Decorative Elements */}
      <div className="absolute bottom-0 left-0 right-0 h-32 bg-gradient-to-t from-white to-transparent z-10"></div>
    </section>
  );
};

export default Hero;
